import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
import merge518753 from './merge'
import splitDf783d from './split'
import removePagesC35b54 from './remove-pages'
import extractPages89d1b2 from './extract-pages'
import reorderC57b01 from './reorder'
import rotateBb1e5f from './rotate'
import compress63097f from './compress'
import repairC8563d from './repair'
import addPageNumbers84e8a4 from './add-page-numbers'
import addWatermarkA0daad from './add-watermark'
import cropB72a3f from './crop'
import ocr306487 from './ocr'
import unlockEa2b39 from './unlock'
import protect8737c7 from './protect'
import sign6e8579 from './sign'
import redact0758bd from './redact'
import compare66ca05 from './compare'
import fromJpg0b0833 from './from-jpg'
import fromWord931f8a from './from-word'
import fromPowerpoint9b3997 from './from-powerpoint'
import fromExcel78ad6b from './from-excel'
import fromHtml7a1ffe from './from-html'
import toJpgC0f87e from './to-jpg'
import toWord450662 from './to-word'
import toPowerpointB951c3 from './to-powerpoint'
import toExcel1b8b87 from './to-excel'
/**
* @see \App\Http\Controllers\Tools\Pdf\MergePdfController::merge
* @see Http/Controllers/Tools/Pdf/MergePdfController.php:22
* @route '/{locale}/tools/pdf/merge'
*/
export const merge = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: merge.url(args, options),
    method: 'get',
})

merge.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/merge',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\MergePdfController::merge
* @see Http/Controllers/Tools/Pdf/MergePdfController.php:22
* @route '/{locale}/tools/pdf/merge'
*/
merge.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return merge.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\MergePdfController::merge
* @see Http/Controllers/Tools/Pdf/MergePdfController.php:22
* @route '/{locale}/tools/pdf/merge'
*/
merge.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: merge.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\MergePdfController::merge
* @see Http/Controllers/Tools/Pdf/MergePdfController.php:22
* @route '/{locale}/tools/pdf/merge'
*/
merge.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: merge.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\MergePdfController::merge
* @see Http/Controllers/Tools/Pdf/MergePdfController.php:22
* @route '/{locale}/tools/pdf/merge'
*/
const mergeForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: merge.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\MergePdfController::merge
* @see Http/Controllers/Tools/Pdf/MergePdfController.php:22
* @route '/{locale}/tools/pdf/merge'
*/
mergeForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: merge.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\MergePdfController::merge
* @see Http/Controllers/Tools/Pdf/MergePdfController.php:22
* @route '/{locale}/tools/pdf/merge'
*/
mergeForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: merge.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

merge.form = mergeForm

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::split
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:20
* @route '/{locale}/tools/pdf/split'
*/
export const split = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: split.url(args, options),
    method: 'get',
})

split.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/split',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::split
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:20
* @route '/{locale}/tools/pdf/split'
*/
split.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return split.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::split
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:20
* @route '/{locale}/tools/pdf/split'
*/
split.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: split.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::split
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:20
* @route '/{locale}/tools/pdf/split'
*/
split.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: split.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::split
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:20
* @route '/{locale}/tools/pdf/split'
*/
const splitForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: split.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::split
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:20
* @route '/{locale}/tools/pdf/split'
*/
splitForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: split.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SplitPdfController::split
* @see Http/Controllers/Tools/Pdf/SplitPdfController.php:20
* @route '/{locale}/tools/pdf/split'
*/
splitForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: split.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

split.form = splitForm

/**
* @see \App\Http\Controllers\Tools\Pdf\RemovePagesController::removePages
* @see Http/Controllers/Tools/Pdf/RemovePagesController.php:22
* @route '/{locale}/tools/pdf/remove-pages'
*/
export const removePages = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: removePages.url(args, options),
    method: 'get',
})

removePages.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/remove-pages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\RemovePagesController::removePages
* @see Http/Controllers/Tools/Pdf/RemovePagesController.php:22
* @route '/{locale}/tools/pdf/remove-pages'
*/
removePages.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return removePages.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\RemovePagesController::removePages
* @see Http/Controllers/Tools/Pdf/RemovePagesController.php:22
* @route '/{locale}/tools/pdf/remove-pages'
*/
removePages.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: removePages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RemovePagesController::removePages
* @see Http/Controllers/Tools/Pdf/RemovePagesController.php:22
* @route '/{locale}/tools/pdf/remove-pages'
*/
removePages.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: removePages.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RemovePagesController::removePages
* @see Http/Controllers/Tools/Pdf/RemovePagesController.php:22
* @route '/{locale}/tools/pdf/remove-pages'
*/
const removePagesForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: removePages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RemovePagesController::removePages
* @see Http/Controllers/Tools/Pdf/RemovePagesController.php:22
* @route '/{locale}/tools/pdf/remove-pages'
*/
removePagesForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: removePages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RemovePagesController::removePages
* @see Http/Controllers/Tools/Pdf/RemovePagesController.php:22
* @route '/{locale}/tools/pdf/remove-pages'
*/
removePagesForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: removePages.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

removePages.form = removePagesForm

/**
* @see \App\Http\Controllers\Tools\Pdf\ExtractPagesController::extractPages
* @see Http/Controllers/Tools/Pdf/ExtractPagesController.php:22
* @route '/{locale}/tools/pdf/extract-pages'
*/
export const extractPages = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: extractPages.url(args, options),
    method: 'get',
})

extractPages.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/extract-pages',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\ExtractPagesController::extractPages
* @see Http/Controllers/Tools/Pdf/ExtractPagesController.php:22
* @route '/{locale}/tools/pdf/extract-pages'
*/
extractPages.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return extractPages.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\ExtractPagesController::extractPages
* @see Http/Controllers/Tools/Pdf/ExtractPagesController.php:22
* @route '/{locale}/tools/pdf/extract-pages'
*/
extractPages.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: extractPages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExtractPagesController::extractPages
* @see Http/Controllers/Tools/Pdf/ExtractPagesController.php:22
* @route '/{locale}/tools/pdf/extract-pages'
*/
extractPages.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: extractPages.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExtractPagesController::extractPages
* @see Http/Controllers/Tools/Pdf/ExtractPagesController.php:22
* @route '/{locale}/tools/pdf/extract-pages'
*/
const extractPagesForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: extractPages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExtractPagesController::extractPages
* @see Http/Controllers/Tools/Pdf/ExtractPagesController.php:22
* @route '/{locale}/tools/pdf/extract-pages'
*/
extractPagesForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: extractPages.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExtractPagesController::extractPages
* @see Http/Controllers/Tools/Pdf/ExtractPagesController.php:22
* @route '/{locale}/tools/pdf/extract-pages'
*/
extractPagesForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: extractPages.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

extractPages.form = extractPagesForm

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::reorder
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:19
* @route '/{locale}/tools/pdf/reorder'
*/
export const reorder = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reorder.url(args, options),
    method: 'get',
})

reorder.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/reorder',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::reorder
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:19
* @route '/{locale}/tools/pdf/reorder'
*/
reorder.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return reorder.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::reorder
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:19
* @route '/{locale}/tools/pdf/reorder'
*/
reorder.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: reorder.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::reorder
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:19
* @route '/{locale}/tools/pdf/reorder'
*/
reorder.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: reorder.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::reorder
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:19
* @route '/{locale}/tools/pdf/reorder'
*/
const reorderForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reorder.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::reorder
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:19
* @route '/{locale}/tools/pdf/reorder'
*/
reorderForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reorder.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ReorderPdfController::reorder
* @see Http/Controllers/Tools/Pdf/ReorderPdfController.php:19
* @route '/{locale}/tools/pdf/reorder'
*/
reorderForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: reorder.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

reorder.form = reorderForm

/**
* @see \App\Http\Controllers\Tools\Pdf\RotatePdfController::rotate
* @see Http/Controllers/Tools/Pdf/RotatePdfController.php:18
* @route '/{locale}/tools/pdf/rotate'
*/
export const rotate = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rotate.url(args, options),
    method: 'get',
})

rotate.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/rotate',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\RotatePdfController::rotate
* @see Http/Controllers/Tools/Pdf/RotatePdfController.php:18
* @route '/{locale}/tools/pdf/rotate'
*/
rotate.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return rotate.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\RotatePdfController::rotate
* @see Http/Controllers/Tools/Pdf/RotatePdfController.php:18
* @route '/{locale}/tools/pdf/rotate'
*/
rotate.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: rotate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RotatePdfController::rotate
* @see Http/Controllers/Tools/Pdf/RotatePdfController.php:18
* @route '/{locale}/tools/pdf/rotate'
*/
rotate.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: rotate.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RotatePdfController::rotate
* @see Http/Controllers/Tools/Pdf/RotatePdfController.php:18
* @route '/{locale}/tools/pdf/rotate'
*/
const rotateForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rotate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RotatePdfController::rotate
* @see Http/Controllers/Tools/Pdf/RotatePdfController.php:18
* @route '/{locale}/tools/pdf/rotate'
*/
rotateForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rotate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RotatePdfController::rotate
* @see Http/Controllers/Tools/Pdf/RotatePdfController.php:18
* @route '/{locale}/tools/pdf/rotate'
*/
rotateForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: rotate.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

rotate.form = rotateForm

/**
* @see \App\Http\Controllers\Tools\Pdf\CompressPdfController::compress
* @see Http/Controllers/Tools/Pdf/CompressPdfController.php:25
* @route '/{locale}/tools/pdf/compress'
*/
export const compress = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: compress.url(args, options),
    method: 'get',
})

compress.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/compress',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\CompressPdfController::compress
* @see Http/Controllers/Tools/Pdf/CompressPdfController.php:25
* @route '/{locale}/tools/pdf/compress'
*/
compress.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return compress.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\CompressPdfController::compress
* @see Http/Controllers/Tools/Pdf/CompressPdfController.php:25
* @route '/{locale}/tools/pdf/compress'
*/
compress.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: compress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CompressPdfController::compress
* @see Http/Controllers/Tools/Pdf/CompressPdfController.php:25
* @route '/{locale}/tools/pdf/compress'
*/
compress.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: compress.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CompressPdfController::compress
* @see Http/Controllers/Tools/Pdf/CompressPdfController.php:25
* @route '/{locale}/tools/pdf/compress'
*/
const compressForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CompressPdfController::compress
* @see Http/Controllers/Tools/Pdf/CompressPdfController.php:25
* @route '/{locale}/tools/pdf/compress'
*/
compressForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compress.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CompressPdfController::compress
* @see Http/Controllers/Tools/Pdf/CompressPdfController.php:25
* @route '/{locale}/tools/pdf/compress'
*/
compressForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compress.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

compress.form = compressForm

/**
* @see \App\Http\Controllers\Tools\Pdf\RepairPdfController::repair
* @see Http/Controllers/Tools/Pdf/RepairPdfController.php:19
* @route '/{locale}/tools/pdf/repair'
*/
export const repair = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: repair.url(args, options),
    method: 'get',
})

repair.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/repair',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\RepairPdfController::repair
* @see Http/Controllers/Tools/Pdf/RepairPdfController.php:19
* @route '/{locale}/tools/pdf/repair'
*/
repair.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return repair.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\RepairPdfController::repair
* @see Http/Controllers/Tools/Pdf/RepairPdfController.php:19
* @route '/{locale}/tools/pdf/repair'
*/
repair.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: repair.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RepairPdfController::repair
* @see Http/Controllers/Tools/Pdf/RepairPdfController.php:19
* @route '/{locale}/tools/pdf/repair'
*/
repair.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: repair.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RepairPdfController::repair
* @see Http/Controllers/Tools/Pdf/RepairPdfController.php:19
* @route '/{locale}/tools/pdf/repair'
*/
const repairForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: repair.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RepairPdfController::repair
* @see Http/Controllers/Tools/Pdf/RepairPdfController.php:19
* @route '/{locale}/tools/pdf/repair'
*/
repairForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: repair.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RepairPdfController::repair
* @see Http/Controllers/Tools/Pdf/RepairPdfController.php:19
* @route '/{locale}/tools/pdf/repair'
*/
repairForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: repair.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

repair.form = repairForm

/**
* @see \App\Http\Controllers\Tools\Pdf\AddPageNumbersController::addPageNumbers
* @see Http/Controllers/Tools/Pdf/AddPageNumbersController.php:17
* @route '/{locale}/tools/pdf/add-page-numbers'
*/
export const addPageNumbers = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: addPageNumbers.url(args, options),
    method: 'get',
})

addPageNumbers.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/add-page-numbers',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\AddPageNumbersController::addPageNumbers
* @see Http/Controllers/Tools/Pdf/AddPageNumbersController.php:17
* @route '/{locale}/tools/pdf/add-page-numbers'
*/
addPageNumbers.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return addPageNumbers.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\AddPageNumbersController::addPageNumbers
* @see Http/Controllers/Tools/Pdf/AddPageNumbersController.php:17
* @route '/{locale}/tools/pdf/add-page-numbers'
*/
addPageNumbers.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: addPageNumbers.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddPageNumbersController::addPageNumbers
* @see Http/Controllers/Tools/Pdf/AddPageNumbersController.php:17
* @route '/{locale}/tools/pdf/add-page-numbers'
*/
addPageNumbers.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: addPageNumbers.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddPageNumbersController::addPageNumbers
* @see Http/Controllers/Tools/Pdf/AddPageNumbersController.php:17
* @route '/{locale}/tools/pdf/add-page-numbers'
*/
const addPageNumbersForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: addPageNumbers.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddPageNumbersController::addPageNumbers
* @see Http/Controllers/Tools/Pdf/AddPageNumbersController.php:17
* @route '/{locale}/tools/pdf/add-page-numbers'
*/
addPageNumbersForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: addPageNumbers.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddPageNumbersController::addPageNumbers
* @see Http/Controllers/Tools/Pdf/AddPageNumbersController.php:17
* @route '/{locale}/tools/pdf/add-page-numbers'
*/
addPageNumbersForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: addPageNumbers.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

addPageNumbers.form = addPageNumbersForm

/**
* @see \App\Http\Controllers\Tools\Pdf\AddWatermarkController::addWatermark
* @see Http/Controllers/Tools/Pdf/AddWatermarkController.php:23
* @route '/{locale}/tools/pdf/add-watermark'
*/
export const addWatermark = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: addWatermark.url(args, options),
    method: 'get',
})

addWatermark.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/add-watermark',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\AddWatermarkController::addWatermark
* @see Http/Controllers/Tools/Pdf/AddWatermarkController.php:23
* @route '/{locale}/tools/pdf/add-watermark'
*/
addWatermark.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return addWatermark.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\AddWatermarkController::addWatermark
* @see Http/Controllers/Tools/Pdf/AddWatermarkController.php:23
* @route '/{locale}/tools/pdf/add-watermark'
*/
addWatermark.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: addWatermark.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddWatermarkController::addWatermark
* @see Http/Controllers/Tools/Pdf/AddWatermarkController.php:23
* @route '/{locale}/tools/pdf/add-watermark'
*/
addWatermark.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: addWatermark.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddWatermarkController::addWatermark
* @see Http/Controllers/Tools/Pdf/AddWatermarkController.php:23
* @route '/{locale}/tools/pdf/add-watermark'
*/
const addWatermarkForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: addWatermark.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddWatermarkController::addWatermark
* @see Http/Controllers/Tools/Pdf/AddWatermarkController.php:23
* @route '/{locale}/tools/pdf/add-watermark'
*/
addWatermarkForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: addWatermark.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\AddWatermarkController::addWatermark
* @see Http/Controllers/Tools/Pdf/AddWatermarkController.php:23
* @route '/{locale}/tools/pdf/add-watermark'
*/
addWatermarkForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: addWatermark.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

addWatermark.form = addWatermarkForm

/**
* @see \App\Http\Controllers\Tools\Pdf\CropPdfController::crop
* @see Http/Controllers/Tools/Pdf/CropPdfController.php:21
* @route '/{locale}/tools/pdf/crop'
*/
export const crop = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: crop.url(args, options),
    method: 'get',
})

crop.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/crop',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\CropPdfController::crop
* @see Http/Controllers/Tools/Pdf/CropPdfController.php:21
* @route '/{locale}/tools/pdf/crop'
*/
crop.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return crop.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\CropPdfController::crop
* @see Http/Controllers/Tools/Pdf/CropPdfController.php:21
* @route '/{locale}/tools/pdf/crop'
*/
crop.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: crop.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CropPdfController::crop
* @see Http/Controllers/Tools/Pdf/CropPdfController.php:21
* @route '/{locale}/tools/pdf/crop'
*/
crop.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: crop.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CropPdfController::crop
* @see Http/Controllers/Tools/Pdf/CropPdfController.php:21
* @route '/{locale}/tools/pdf/crop'
*/
const cropForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: crop.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CropPdfController::crop
* @see Http/Controllers/Tools/Pdf/CropPdfController.php:21
* @route '/{locale}/tools/pdf/crop'
*/
cropForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: crop.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\CropPdfController::crop
* @see Http/Controllers/Tools/Pdf/CropPdfController.php:21
* @route '/{locale}/tools/pdf/crop'
*/
cropForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: crop.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

crop.form = cropForm

/**
* @see \App\Http\Controllers\Tools\Pdf\OcrPdfController::ocr
* @see Http/Controllers/Tools/Pdf/OcrPdfController.php:17
* @route '/{locale}/tools/pdf/ocr'
*/
export const ocr = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ocr.url(args, options),
    method: 'get',
})

ocr.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/ocr',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\OcrPdfController::ocr
* @see Http/Controllers/Tools/Pdf/OcrPdfController.php:17
* @route '/{locale}/tools/pdf/ocr'
*/
ocr.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return ocr.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\OcrPdfController::ocr
* @see Http/Controllers/Tools/Pdf/OcrPdfController.php:17
* @route '/{locale}/tools/pdf/ocr'
*/
ocr.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ocr.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\OcrPdfController::ocr
* @see Http/Controllers/Tools/Pdf/OcrPdfController.php:17
* @route '/{locale}/tools/pdf/ocr'
*/
ocr.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ocr.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\OcrPdfController::ocr
* @see Http/Controllers/Tools/Pdf/OcrPdfController.php:17
* @route '/{locale}/tools/pdf/ocr'
*/
const ocrForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ocr.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\OcrPdfController::ocr
* @see Http/Controllers/Tools/Pdf/OcrPdfController.php:17
* @route '/{locale}/tools/pdf/ocr'
*/
ocrForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ocr.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\OcrPdfController::ocr
* @see Http/Controllers/Tools/Pdf/OcrPdfController.php:17
* @route '/{locale}/tools/pdf/ocr'
*/
ocrForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ocr.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ocr.form = ocrForm

/**
* @see \App\Http\Controllers\Tools\Pdf\UnlockPdfController::unlock
* @see Http/Controllers/Tools/Pdf/UnlockPdfController.php:18
* @route '/{locale}/tools/pdf/unlock'
*/
export const unlock = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: unlock.url(args, options),
    method: 'get',
})

unlock.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/unlock',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\UnlockPdfController::unlock
* @see Http/Controllers/Tools/Pdf/UnlockPdfController.php:18
* @route '/{locale}/tools/pdf/unlock'
*/
unlock.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return unlock.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\UnlockPdfController::unlock
* @see Http/Controllers/Tools/Pdf/UnlockPdfController.php:18
* @route '/{locale}/tools/pdf/unlock'
*/
unlock.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: unlock.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\UnlockPdfController::unlock
* @see Http/Controllers/Tools/Pdf/UnlockPdfController.php:18
* @route '/{locale}/tools/pdf/unlock'
*/
unlock.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: unlock.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\UnlockPdfController::unlock
* @see Http/Controllers/Tools/Pdf/UnlockPdfController.php:18
* @route '/{locale}/tools/pdf/unlock'
*/
const unlockForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: unlock.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\UnlockPdfController::unlock
* @see Http/Controllers/Tools/Pdf/UnlockPdfController.php:18
* @route '/{locale}/tools/pdf/unlock'
*/
unlockForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: unlock.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\UnlockPdfController::unlock
* @see Http/Controllers/Tools/Pdf/UnlockPdfController.php:18
* @route '/{locale}/tools/pdf/unlock'
*/
unlockForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: unlock.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

unlock.form = unlockForm

/**
* @see \App\Http\Controllers\Tools\Pdf\ProtectPdfController::protect
* @see Http/Controllers/Tools/Pdf/ProtectPdfController.php:18
* @route '/{locale}/tools/pdf/protect'
*/
export const protect = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: protect.url(args, options),
    method: 'get',
})

protect.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/protect',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\ProtectPdfController::protect
* @see Http/Controllers/Tools/Pdf/ProtectPdfController.php:18
* @route '/{locale}/tools/pdf/protect'
*/
protect.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return protect.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\ProtectPdfController::protect
* @see Http/Controllers/Tools/Pdf/ProtectPdfController.php:18
* @route '/{locale}/tools/pdf/protect'
*/
protect.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: protect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ProtectPdfController::protect
* @see Http/Controllers/Tools/Pdf/ProtectPdfController.php:18
* @route '/{locale}/tools/pdf/protect'
*/
protect.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: protect.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ProtectPdfController::protect
* @see Http/Controllers/Tools/Pdf/ProtectPdfController.php:18
* @route '/{locale}/tools/pdf/protect'
*/
const protectForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: protect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ProtectPdfController::protect
* @see Http/Controllers/Tools/Pdf/ProtectPdfController.php:18
* @route '/{locale}/tools/pdf/protect'
*/
protectForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: protect.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ProtectPdfController::protect
* @see Http/Controllers/Tools/Pdf/ProtectPdfController.php:18
* @route '/{locale}/tools/pdf/protect'
*/
protectForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: protect.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

protect.form = protectForm

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::sign
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:19
* @route '/{locale}/tools/pdf/sign'
*/
export const sign = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sign.url(args, options),
    method: 'get',
})

sign.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/sign',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::sign
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:19
* @route '/{locale}/tools/pdf/sign'
*/
sign.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return sign.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::sign
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:19
* @route '/{locale}/tools/pdf/sign'
*/
sign.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: sign.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::sign
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:19
* @route '/{locale}/tools/pdf/sign'
*/
sign.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: sign.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::sign
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:19
* @route '/{locale}/tools/pdf/sign'
*/
const signForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sign.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::sign
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:19
* @route '/{locale}/tools/pdf/sign'
*/
signForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sign.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\SignPdfController::sign
* @see Http/Controllers/Tools/Pdf/SignPdfController.php:19
* @route '/{locale}/tools/pdf/sign'
*/
signForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: sign.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

sign.form = signForm

/**
* @see \App\Http\Controllers\Tools\Pdf\RedactPdfController::redact
* @see Http/Controllers/Tools/Pdf/RedactPdfController.php:19
* @route '/{locale}/tools/pdf/redact'
*/
export const redact = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: redact.url(args, options),
    method: 'get',
})

redact.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/redact',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\RedactPdfController::redact
* @see Http/Controllers/Tools/Pdf/RedactPdfController.php:19
* @route '/{locale}/tools/pdf/redact'
*/
redact.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return redact.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\RedactPdfController::redact
* @see Http/Controllers/Tools/Pdf/RedactPdfController.php:19
* @route '/{locale}/tools/pdf/redact'
*/
redact.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: redact.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RedactPdfController::redact
* @see Http/Controllers/Tools/Pdf/RedactPdfController.php:19
* @route '/{locale}/tools/pdf/redact'
*/
redact.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: redact.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RedactPdfController::redact
* @see Http/Controllers/Tools/Pdf/RedactPdfController.php:19
* @route '/{locale}/tools/pdf/redact'
*/
const redactForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: redact.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RedactPdfController::redact
* @see Http/Controllers/Tools/Pdf/RedactPdfController.php:19
* @route '/{locale}/tools/pdf/redact'
*/
redactForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: redact.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\RedactPdfController::redact
* @see Http/Controllers/Tools/Pdf/RedactPdfController.php:19
* @route '/{locale}/tools/pdf/redact'
*/
redactForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: redact.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

redact.form = redactForm

/**
* @see \App\Http\Controllers\Tools\Pdf\ComparePdfController::compare
* @see Http/Controllers/Tools/Pdf/ComparePdfController.php:16
* @route '/{locale}/tools/pdf/compare'
*/
export const compare = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: compare.url(args, options),
    method: 'get',
})

compare.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/compare',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\ComparePdfController::compare
* @see Http/Controllers/Tools/Pdf/ComparePdfController.php:16
* @route '/{locale}/tools/pdf/compare'
*/
compare.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return compare.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\ComparePdfController::compare
* @see Http/Controllers/Tools/Pdf/ComparePdfController.php:16
* @route '/{locale}/tools/pdf/compare'
*/
compare.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: compare.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ComparePdfController::compare
* @see Http/Controllers/Tools/Pdf/ComparePdfController.php:16
* @route '/{locale}/tools/pdf/compare'
*/
compare.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: compare.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ComparePdfController::compare
* @see Http/Controllers/Tools/Pdf/ComparePdfController.php:16
* @route '/{locale}/tools/pdf/compare'
*/
const compareForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compare.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ComparePdfController::compare
* @see Http/Controllers/Tools/Pdf/ComparePdfController.php:16
* @route '/{locale}/tools/pdf/compare'
*/
compareForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compare.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ComparePdfController::compare
* @see Http/Controllers/Tools/Pdf/ComparePdfController.php:16
* @route '/{locale}/tools/pdf/compare'
*/
compareForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: compare.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

compare.form = compareForm

/**
* @see \App\Http\Controllers\Tools\Pdf\JpgToPdfController::fromJpg
* @see Http/Controllers/Tools/Pdf/JpgToPdfController.php:17
* @route '/{locale}/tools/pdf/from-jpg'
*/
export const fromJpg = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromJpg.url(args, options),
    method: 'get',
})

fromJpg.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/from-jpg',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\JpgToPdfController::fromJpg
* @see Http/Controllers/Tools/Pdf/JpgToPdfController.php:17
* @route '/{locale}/tools/pdf/from-jpg'
*/
fromJpg.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return fromJpg.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\JpgToPdfController::fromJpg
* @see Http/Controllers/Tools/Pdf/JpgToPdfController.php:17
* @route '/{locale}/tools/pdf/from-jpg'
*/
fromJpg.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromJpg.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\JpgToPdfController::fromJpg
* @see Http/Controllers/Tools/Pdf/JpgToPdfController.php:17
* @route '/{locale}/tools/pdf/from-jpg'
*/
fromJpg.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: fromJpg.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\JpgToPdfController::fromJpg
* @see Http/Controllers/Tools/Pdf/JpgToPdfController.php:17
* @route '/{locale}/tools/pdf/from-jpg'
*/
const fromJpgForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromJpg.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\JpgToPdfController::fromJpg
* @see Http/Controllers/Tools/Pdf/JpgToPdfController.php:17
* @route '/{locale}/tools/pdf/from-jpg'
*/
fromJpgForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromJpg.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\JpgToPdfController::fromJpg
* @see Http/Controllers/Tools/Pdf/JpgToPdfController.php:17
* @route '/{locale}/tools/pdf/from-jpg'
*/
fromJpgForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromJpg.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

fromJpg.form = fromJpgForm

/**
* @see \App\Http\Controllers\Tools\Pdf\WordToPdfController::fromWord
* @see Http/Controllers/Tools/Pdf/WordToPdfController.php:19
* @route '/{locale}/tools/pdf/from-word'
*/
export const fromWord = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromWord.url(args, options),
    method: 'get',
})

fromWord.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/from-word',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\WordToPdfController::fromWord
* @see Http/Controllers/Tools/Pdf/WordToPdfController.php:19
* @route '/{locale}/tools/pdf/from-word'
*/
fromWord.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return fromWord.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\WordToPdfController::fromWord
* @see Http/Controllers/Tools/Pdf/WordToPdfController.php:19
* @route '/{locale}/tools/pdf/from-word'
*/
fromWord.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromWord.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\WordToPdfController::fromWord
* @see Http/Controllers/Tools/Pdf/WordToPdfController.php:19
* @route '/{locale}/tools/pdf/from-word'
*/
fromWord.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: fromWord.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\WordToPdfController::fromWord
* @see Http/Controllers/Tools/Pdf/WordToPdfController.php:19
* @route '/{locale}/tools/pdf/from-word'
*/
const fromWordForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromWord.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\WordToPdfController::fromWord
* @see Http/Controllers/Tools/Pdf/WordToPdfController.php:19
* @route '/{locale}/tools/pdf/from-word'
*/
fromWordForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromWord.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\WordToPdfController::fromWord
* @see Http/Controllers/Tools/Pdf/WordToPdfController.php:19
* @route '/{locale}/tools/pdf/from-word'
*/
fromWordForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromWord.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

fromWord.form = fromWordForm

/**
* @see \App\Http\Controllers\Tools\Pdf\PowerPointToPdfController::fromPowerpoint
* @see Http/Controllers/Tools/Pdf/PowerPointToPdfController.php:18
* @route '/{locale}/tools/pdf/from-powerpoint'
*/
export const fromPowerpoint = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromPowerpoint.url(args, options),
    method: 'get',
})

fromPowerpoint.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/from-powerpoint',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\PowerPointToPdfController::fromPowerpoint
* @see Http/Controllers/Tools/Pdf/PowerPointToPdfController.php:18
* @route '/{locale}/tools/pdf/from-powerpoint'
*/
fromPowerpoint.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return fromPowerpoint.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\PowerPointToPdfController::fromPowerpoint
* @see Http/Controllers/Tools/Pdf/PowerPointToPdfController.php:18
* @route '/{locale}/tools/pdf/from-powerpoint'
*/
fromPowerpoint.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromPowerpoint.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PowerPointToPdfController::fromPowerpoint
* @see Http/Controllers/Tools/Pdf/PowerPointToPdfController.php:18
* @route '/{locale}/tools/pdf/from-powerpoint'
*/
fromPowerpoint.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: fromPowerpoint.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PowerPointToPdfController::fromPowerpoint
* @see Http/Controllers/Tools/Pdf/PowerPointToPdfController.php:18
* @route '/{locale}/tools/pdf/from-powerpoint'
*/
const fromPowerpointForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromPowerpoint.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PowerPointToPdfController::fromPowerpoint
* @see Http/Controllers/Tools/Pdf/PowerPointToPdfController.php:18
* @route '/{locale}/tools/pdf/from-powerpoint'
*/
fromPowerpointForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromPowerpoint.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PowerPointToPdfController::fromPowerpoint
* @see Http/Controllers/Tools/Pdf/PowerPointToPdfController.php:18
* @route '/{locale}/tools/pdf/from-powerpoint'
*/
fromPowerpointForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromPowerpoint.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

fromPowerpoint.form = fromPowerpointForm

/**
* @see \App\Http\Controllers\Tools\Pdf\ExcelToPdfController::fromExcel
* @see Http/Controllers/Tools/Pdf/ExcelToPdfController.php:18
* @route '/{locale}/tools/pdf/from-excel'
*/
export const fromExcel = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromExcel.url(args, options),
    method: 'get',
})

fromExcel.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/from-excel',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\ExcelToPdfController::fromExcel
* @see Http/Controllers/Tools/Pdf/ExcelToPdfController.php:18
* @route '/{locale}/tools/pdf/from-excel'
*/
fromExcel.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return fromExcel.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\ExcelToPdfController::fromExcel
* @see Http/Controllers/Tools/Pdf/ExcelToPdfController.php:18
* @route '/{locale}/tools/pdf/from-excel'
*/
fromExcel.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromExcel.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExcelToPdfController::fromExcel
* @see Http/Controllers/Tools/Pdf/ExcelToPdfController.php:18
* @route '/{locale}/tools/pdf/from-excel'
*/
fromExcel.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: fromExcel.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExcelToPdfController::fromExcel
* @see Http/Controllers/Tools/Pdf/ExcelToPdfController.php:18
* @route '/{locale}/tools/pdf/from-excel'
*/
const fromExcelForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromExcel.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExcelToPdfController::fromExcel
* @see Http/Controllers/Tools/Pdf/ExcelToPdfController.php:18
* @route '/{locale}/tools/pdf/from-excel'
*/
fromExcelForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromExcel.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\ExcelToPdfController::fromExcel
* @see Http/Controllers/Tools/Pdf/ExcelToPdfController.php:18
* @route '/{locale}/tools/pdf/from-excel'
*/
fromExcelForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromExcel.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

fromExcel.form = fromExcelForm

/**
* @see \App\Http\Controllers\Tools\Pdf\HtmlToPdfController::fromHtml
* @see Http/Controllers/Tools/Pdf/HtmlToPdfController.php:18
* @route '/{locale}/tools/pdf/from-html'
*/
export const fromHtml = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromHtml.url(args, options),
    method: 'get',
})

fromHtml.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/from-html',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\HtmlToPdfController::fromHtml
* @see Http/Controllers/Tools/Pdf/HtmlToPdfController.php:18
* @route '/{locale}/tools/pdf/from-html'
*/
fromHtml.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return fromHtml.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\HtmlToPdfController::fromHtml
* @see Http/Controllers/Tools/Pdf/HtmlToPdfController.php:18
* @route '/{locale}/tools/pdf/from-html'
*/
fromHtml.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: fromHtml.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\HtmlToPdfController::fromHtml
* @see Http/Controllers/Tools/Pdf/HtmlToPdfController.php:18
* @route '/{locale}/tools/pdf/from-html'
*/
fromHtml.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: fromHtml.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\HtmlToPdfController::fromHtml
* @see Http/Controllers/Tools/Pdf/HtmlToPdfController.php:18
* @route '/{locale}/tools/pdf/from-html'
*/
const fromHtmlForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromHtml.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\HtmlToPdfController::fromHtml
* @see Http/Controllers/Tools/Pdf/HtmlToPdfController.php:18
* @route '/{locale}/tools/pdf/from-html'
*/
fromHtmlForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromHtml.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\HtmlToPdfController::fromHtml
* @see Http/Controllers/Tools/Pdf/HtmlToPdfController.php:18
* @route '/{locale}/tools/pdf/from-html'
*/
fromHtmlForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: fromHtml.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

fromHtml.form = fromHtmlForm

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToJpgController::toJpg
* @see Http/Controllers/Tools/Pdf/PdfToJpgController.php:26
* @route '/{locale}/tools/pdf/to-jpg'
*/
export const toJpg = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toJpg.url(args, options),
    method: 'get',
})

toJpg.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/to-jpg',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToJpgController::toJpg
* @see Http/Controllers/Tools/Pdf/PdfToJpgController.php:26
* @route '/{locale}/tools/pdf/to-jpg'
*/
toJpg.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return toJpg.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToJpgController::toJpg
* @see Http/Controllers/Tools/Pdf/PdfToJpgController.php:26
* @route '/{locale}/tools/pdf/to-jpg'
*/
toJpg.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toJpg.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToJpgController::toJpg
* @see Http/Controllers/Tools/Pdf/PdfToJpgController.php:26
* @route '/{locale}/tools/pdf/to-jpg'
*/
toJpg.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: toJpg.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToJpgController::toJpg
* @see Http/Controllers/Tools/Pdf/PdfToJpgController.php:26
* @route '/{locale}/tools/pdf/to-jpg'
*/
const toJpgForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toJpg.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToJpgController::toJpg
* @see Http/Controllers/Tools/Pdf/PdfToJpgController.php:26
* @route '/{locale}/tools/pdf/to-jpg'
*/
toJpgForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toJpg.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToJpgController::toJpg
* @see Http/Controllers/Tools/Pdf/PdfToJpgController.php:26
* @route '/{locale}/tools/pdf/to-jpg'
*/
toJpgForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toJpg.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

toJpg.form = toJpgForm

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToWordController::toWord
* @see Http/Controllers/Tools/Pdf/PdfToWordController.php:19
* @route '/{locale}/tools/pdf/to-word'
*/
export const toWord = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toWord.url(args, options),
    method: 'get',
})

toWord.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/to-word',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToWordController::toWord
* @see Http/Controllers/Tools/Pdf/PdfToWordController.php:19
* @route '/{locale}/tools/pdf/to-word'
*/
toWord.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return toWord.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToWordController::toWord
* @see Http/Controllers/Tools/Pdf/PdfToWordController.php:19
* @route '/{locale}/tools/pdf/to-word'
*/
toWord.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toWord.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToWordController::toWord
* @see Http/Controllers/Tools/Pdf/PdfToWordController.php:19
* @route '/{locale}/tools/pdf/to-word'
*/
toWord.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: toWord.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToWordController::toWord
* @see Http/Controllers/Tools/Pdf/PdfToWordController.php:19
* @route '/{locale}/tools/pdf/to-word'
*/
const toWordForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toWord.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToWordController::toWord
* @see Http/Controllers/Tools/Pdf/PdfToWordController.php:19
* @route '/{locale}/tools/pdf/to-word'
*/
toWordForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toWord.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToWordController::toWord
* @see Http/Controllers/Tools/Pdf/PdfToWordController.php:19
* @route '/{locale}/tools/pdf/to-word'
*/
toWordForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toWord.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

toWord.form = toWordForm

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToPowerPointController::toPowerpoint
* @see Http/Controllers/Tools/Pdf/PdfToPowerPointController.php:18
* @route '/{locale}/tools/pdf/to-powerpoint'
*/
export const toPowerpoint = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toPowerpoint.url(args, options),
    method: 'get',
})

toPowerpoint.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/to-powerpoint',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToPowerPointController::toPowerpoint
* @see Http/Controllers/Tools/Pdf/PdfToPowerPointController.php:18
* @route '/{locale}/tools/pdf/to-powerpoint'
*/
toPowerpoint.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return toPowerpoint.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToPowerPointController::toPowerpoint
* @see Http/Controllers/Tools/Pdf/PdfToPowerPointController.php:18
* @route '/{locale}/tools/pdf/to-powerpoint'
*/
toPowerpoint.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toPowerpoint.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToPowerPointController::toPowerpoint
* @see Http/Controllers/Tools/Pdf/PdfToPowerPointController.php:18
* @route '/{locale}/tools/pdf/to-powerpoint'
*/
toPowerpoint.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: toPowerpoint.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToPowerPointController::toPowerpoint
* @see Http/Controllers/Tools/Pdf/PdfToPowerPointController.php:18
* @route '/{locale}/tools/pdf/to-powerpoint'
*/
const toPowerpointForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toPowerpoint.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToPowerPointController::toPowerpoint
* @see Http/Controllers/Tools/Pdf/PdfToPowerPointController.php:18
* @route '/{locale}/tools/pdf/to-powerpoint'
*/
toPowerpointForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toPowerpoint.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToPowerPointController::toPowerpoint
* @see Http/Controllers/Tools/Pdf/PdfToPowerPointController.php:18
* @route '/{locale}/tools/pdf/to-powerpoint'
*/
toPowerpointForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toPowerpoint.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

toPowerpoint.form = toPowerpointForm

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToExcelController::toExcel
* @see Http/Controllers/Tools/Pdf/PdfToExcelController.php:18
* @route '/{locale}/tools/pdf/to-excel'
*/
export const toExcel = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toExcel.url(args, options),
    method: 'get',
})

toExcel.definition = {
    methods: ["get","head"],
    url: '/{locale}/tools/pdf/to-excel',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToExcelController::toExcel
* @see Http/Controllers/Tools/Pdf/PdfToExcelController.php:18
* @route '/{locale}/tools/pdf/to-excel'
*/
toExcel.url = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { locale: args }
    }

    if (Array.isArray(args)) {
        args = {
            locale: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        locale: args.locale,
    }

    return toExcel.definition.url
            .replace('{locale}', parsedArgs.locale.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToExcelController::toExcel
* @see Http/Controllers/Tools/Pdf/PdfToExcelController.php:18
* @route '/{locale}/tools/pdf/to-excel'
*/
toExcel.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: toExcel.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToExcelController::toExcel
* @see Http/Controllers/Tools/Pdf/PdfToExcelController.php:18
* @route '/{locale}/tools/pdf/to-excel'
*/
toExcel.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: toExcel.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToExcelController::toExcel
* @see Http/Controllers/Tools/Pdf/PdfToExcelController.php:18
* @route '/{locale}/tools/pdf/to-excel'
*/
const toExcelForm = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toExcel.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToExcelController::toExcel
* @see Http/Controllers/Tools/Pdf/PdfToExcelController.php:18
* @route '/{locale}/tools/pdf/to-excel'
*/
toExcelForm.get = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toExcel.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tools\Pdf\PdfToExcelController::toExcel
* @see Http/Controllers/Tools/Pdf/PdfToExcelController.php:18
* @route '/{locale}/tools/pdf/to-excel'
*/
toExcelForm.head = (args: { locale: string | number } | [locale: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: toExcel.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

toExcel.form = toExcelForm

const pdf = {
    merge: Object.assign(merge, merge518753),
    split: Object.assign(split, splitDf783d),
    removePages: Object.assign(removePages, removePagesC35b54),
    extractPages: Object.assign(extractPages, extractPages89d1b2),
    reorder: Object.assign(reorder, reorderC57b01),
    rotate: Object.assign(rotate, rotateBb1e5f),
    compress: Object.assign(compress, compress63097f),
    repair: Object.assign(repair, repairC8563d),
    addPageNumbers: Object.assign(addPageNumbers, addPageNumbers84e8a4),
    addWatermark: Object.assign(addWatermark, addWatermarkA0daad),
    crop: Object.assign(crop, cropB72a3f),
    ocr: Object.assign(ocr, ocr306487),
    unlock: Object.assign(unlock, unlockEa2b39),
    protect: Object.assign(protect, protect8737c7),
    sign: Object.assign(sign, sign6e8579),
    redact: Object.assign(redact, redact0758bd),
    compare: Object.assign(compare, compare66ca05),
    fromJpg: Object.assign(fromJpg, fromJpg0b0833),
    fromWord: Object.assign(fromWord, fromWord931f8a),
    fromPowerpoint: Object.assign(fromPowerpoint, fromPowerpoint9b3997),
    fromExcel: Object.assign(fromExcel, fromExcel78ad6b),
    fromHtml: Object.assign(fromHtml, fromHtml7a1ffe),
    toJpg: Object.assign(toJpg, toJpgC0f87e),
    toWord: Object.assign(toWord, toWord450662),
    toPowerpoint: Object.assign(toPowerpoint, toPowerpointB951c3),
    toExcel: Object.assign(toExcel, toExcel1b8b87),
}

export default pdf